module.exports = __webpack_public_path__ + "img/favicon.1d3db3ee.png";